import React, { Component } from "react";
import { Link } from "react-router-dom";
// components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";

const App = props => {
  const posts = props.postData;
  let img = [];

  for (let postNumber in posts) {
    let post = posts[postNumber];
    if (post && post._embedded) {
      if (post._embedded["wp:featuredmedia"]) {
        let url =
          post._embedded["wp:featuredmedia"][0].media_details.sizes[
            "medium_large"
          ];
        if (!url) {
          url = post._embedded["wp:featuredmedia"][0].source_url;
        } else {
          url =
            post._embedded["wp:featuredmedia"][0].media_details.sizes[
              "medium_large"
            ].source_url;
        }
        img.push([url, post.slug, post.title.rendered, post.id]);
      }
    }
  }

  function imgs() {
    return img.map(image => {
      return (
        <div
          key={image[3]}
          className="small-6 medium-3 columns home-image__container"
        >
          <Link to={`/project/${image[1]}`}>
            <figure className="home-figure">
              <img className="home-image" src={image[0]} alt="image" />
              <figcaption>{image[2]}</figcaption>
            </figure>
          </Link>
        </div>
      );
    });
  }

  function home() {
    return (
      <div className="App__intro">
        <div className="row collapse expanded">{imgs()}</div>
        <Preloader
          preloader={props.scrollPreloader}
          type="preloader--smaller"
        />
      </div>
    );
  }

  return (
    <div className="App App--home">
      <Header />
      {home()}

      <Footer />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js